import React, { useState } from "react";
import { createTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Stack,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Button,
  Collapse,
} from "@mui/material";

import MenuIcon from "@mui/icons-material/Menu";
import logoImage from "./assets/home/logo.svg";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";

function Home() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuName, setMenuName] = useState("");
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navigate = useNavigate();

  const menuItems = [
    { text: { sl: 1, itemName: "Home" } },
    {
      text: { sl: 2, itemName: "Solutions" },
      subItems: [
        {
          text: { sl: 3, itemName: "Web-Based Solution" },
          subItems: [
            { sl: 4, itemName: "Web-App Development" },
            { sl: 5, itemName: "E-Commerce Development" },
            { sl: 6, itemName: "Application Portal" },
          ],
        },
        {
          text: { sl: 7, itemName: "Mobility Solutions" },
          subItems: [
            { sl: 8, itemName: "Android Development" },
            { sl: 9, itemName: "iOS Development" },
            { sl: 10, itemName: "Cross Platform Development" },
          ],
        },
        { text: { sl: 11, itemName: "Software Solutions" } },
        { text: { sl: 12, itemName: "UI/UX Solutions" } },
        { text: { sl: 13, itemName: "DevOps Solutions" } },
        { text: { sl: 14, itemName: "POS Development" } },
      ],
    },
    {
      text: { sl: 15, itemName: "Training" },
      subItems: [
        { sl: 16, itemName: "Android Training" },
        { sl: 17, itemName: "iOS Training" },
        { sl: 18, itemName: "Backend And DevOps" },
      ],
    },
    { text: { sl: 19, itemName: "About Linus" } },
    { text: { sl: 20, itemName: "Contact Us" } },
  ];

  const handleMenuOpen = (event, name) => {
    setAnchorEl(event.currentTarget);
    setMenuName(name);
  };

  const handleMenuClose = (itemClicked) => {
    handleClick(itemClicked);
    setAnchorEl(null);
    setMenuName("");
  };

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const theme = createTheme({
    components: {
      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: "black",
            "&:hover": {
              backgroundColor: "#f0f0f0",
              color: "#764ba2",
            },
          },
        },
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: "#fff",
          },
        },
      },
    },
  });

  const [expandedMenus, setExpandedMenus] = useState({});

  const toggleExpand = (key) => {
    setExpandedMenus((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const isMobile = useMediaQuery(theme.breakpoints.down("md")); // Mobile breakpoint
  const [hoveredId, setHoveredId] = useState(100);

  const handleHover = (isHovered, id) => {
    if (isHovered) {
      setHoveredId(id);
    } else {
      setHoveredId(null);
    }
  };

  const handleClick = (itemClicked) => {
    setMenuName("");
    setDrawerOpen(false);
    if (itemClicked == 1) {
      navigate("/");
    }
    if (itemClicked == 4) {
      navigate("/web-application-development");
    }
    if (itemClicked == 5) {
      navigate("/e-commerce-development");
    }
    if (itemClicked == 6) {
      navigate("/application_portal");
    }
    if (itemClicked == 7) {
      navigate("/application_portal");
    }
    if (itemClicked == 8) {
      navigate("/android_development");
    }
    if (itemClicked == 9) {
      navigate("/ios_development");
    }
    if (itemClicked == 10) {
      navigate("/cross_platform_technology");
    }
    if (itemClicked == 11) {
      navigate("/software_solutions");
    }
    if (itemClicked == 12) {
      navigate("/ui_ux_solutions");
    }
    if (itemClicked == 13) {
      navigate("/dev_ops_solution");
    }
    if (itemClicked == 14) {
      navigate("/pos_development_solution");
    }
    if (itemClicked == 16) {
      navigate("/android_training");
    }
    if (itemClicked == 17) {
      navigate("/ios_training");
    }
    if (itemClicked == 18) {
      navigate("/server_devops_training");
    }
    if (itemClicked == 19) {
      navigate("/about_us_linus100");
    }
    if (itemClicked == 20) {
      navigate("/contact_us");
    }

    console.log("Clicked item:", itemClicked);
  };

  return (
    <Box>
      <AppBar position="fixed">
        <Toolbar
          sx={{ justifyContent: "space-between", background: "#FFFFFF" }}
        >
          <Box
            onClick={() => {
              handleClick(1);
            }}
            sx={{
              width: "180px",
              height: "80px",
              backgroundImage: `url(${logoImage})`,
              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "contain",
            }}
          />

          {/* Desktop Menu */}
          {!isMobile && (
            <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
              <Stack direction="row" spacing={2}>
                {menuItems.map((item) => (
                  <Box
                    key={item.text.sl}
                    onMouseEnter={(e) => handleMenuOpen(e, item.text.itemName)}
                    onMouseLeave={handleMenuClose}
                  >
                    <Button
                      sx={{
                        color: "black",
                        "&:hover": {
                          backgroundColor: "#e0e0e0",
                        },
                      }}
                      onClick={() => handleClick(item.text.sl)}
                    >
                      {item.text.itemName}
                    </Button>

                    {item.subItems && item.subItems.length > 0 && (
                      <Menu
                        anchorEl={anchorEl}
                        open={menuName === item.text.itemName}
                        onClose={handleMenuClose}
                      >
                        {item.subItems.flatMap((subItem) => {
                          const items = [
                            <MenuItem
                              key={subItem.text ? subItem.text.sl : subItem.sl}
                              onClick={() =>
                                handleClick(
                                  subItem.text ? subItem.text.sl : subItem.sl
                                )
                              }
                              onMouseEnter={() => handleHover(true)}
                              onMouseLeave={() => handleHover(true)}
                              sx={{
                                color: "black",
                                "&:hover": {
                                  backgroundColor: "#f0f0f0",
                                  color: "#764ba2",
                                },
                              }}
                            >
                              {subItem.text
                                ? subItem.text.itemName
                                : subItem.itemName}
                            </MenuItem>,
                          ];

                          if (subItem.subItems && subItem.subItems.length > 0) {
                            items.push(
                              ...subItem.subItems.map((nestedSub) => (
                                <MenuItem
                                  key={nestedSub.sl}
                                  onClick={() => handleMenuClose(nestedSub.sl)}
                                  sx={{
                                    color: "#555",
                                    pl: 4,
                                    fontSize: "0.9rem",
                                    "&:hover": {
                                      backgroundColor: "#f0f0f0",
                                      color: "#764ba2",
                                    },
                                  }}
                                >
                                  {nestedSub.itemName}
                                </MenuItem>
                              ))
                            );
                          }

                          return items;
                        })}
                      </Menu>
                    )}
                  </Box>
                ))}
              </Stack>
            </Box>
          )}

          {/* Hamburger Menu for Mobile */}
          {isMobile && (
            <IconButton
              sx={{
                color: "black",
                "&:hover": {
                  backgroundColor: "#e0e0e0",
                },
              }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
          )}
        </Toolbar>
      </AppBar>

      {/* Drawer for Mobile Menu */}
      <Drawer anchor="left" open={drawerOpen} onClose={toggleDrawer(false)}>
        <List sx={{ width: 250 }}>
          {menuItems.map((item) => {
            const hasSub = !!item.subItems;
            const isOpen = expandedMenus[item.text.sl];

            return (
              <React.Fragment key={item.text.sl}>
                <ListItem
                  button
                  onClick={() =>
                    hasSub
                      ? toggleExpand(item.text.sl)
                      : handleClick(item.text.sl)
                  }
                >
                  <ListItemText primary={item.text.itemName} />
                  {hasSub && (
                    <IconButton size="small">
                      {isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                    </IconButton>
                  )}
                </ListItem>

                {/* Collapse SubItems */}
                <Collapse in={isOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.subItems?.map((subItem) => {
                      const hasNested = !!subItem.subItems;
                      const subKey = subItem.text?.sl || subItem.sl;
                      const isSubOpen = expandedMenus[subKey];

                      return (
                        <React.Fragment key={subKey}>
                          <ListItem
                            button
                            sx={{ pl: 4 }}
                            onClick={() =>
                              hasNested
                                ? toggleExpand(subKey)
                                : handleClick(subKey)
                            }
                          >
                            <ListItemText
                              primary={
                                subItem.text?.itemName || subItem.itemName
                              }
                            />
                            {hasNested && (
                              <IconButton size="small">
                                {isSubOpen ? (
                                  <ArrowDropUpIcon />
                                ) : (
                                  <ArrowDropDownIcon />
                                )}
                              </IconButton>
                            )}
                          </ListItem>

                          {/* Nested submenu */}
                          <Collapse in={isSubOpen} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                              {subItem.subItems?.map((nestedSub) => (
                                <ListItem
                                  key={nestedSub.sl}
                                  button
                                  sx={{ pl: 8 }}
                                  onClick={() => handleClick(nestedSub.sl)}
                                >
                                  <ListItemText primary={nestedSub.itemName} />
                                </ListItem>
                              ))}
                            </List>
                          </Collapse>
                        </React.Fragment>
                      );
                    })}
                  </List>
                </Collapse>
              </React.Fragment>
            );
          })}
        </List>
      </Drawer>
    </Box>
  );
}

export default Home;
